import { render, staticRenderFns } from "./AddVault.vue?vue&type=template&id=efd42d48&scoped=true"
import script from "./AddVault.vue?vue&type=script&lang=js"
export * from "./AddVault.vue?vue&type=script&lang=js"
import style0 from "./AddVault.vue?vue&type=style&index=0&id=efd42d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd42d48",
  null
  
)

export default component.exports